import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

export const services = [
  {
    id: "eco-wash",
    title: "ECO Wash Package",
    description: "Our innovative \"Waterless Exterior Hand Wash\" removes all dirt, leaving your paint with a streak-free & wax-like finish, and protects your paint.",
  },
  {
    id: "complete-detail",
    title: "Complete Detail Package",
    description: "Complete Detail Package is the ultimate option for your car. This package includes every needed step to make your car shine inside & out again.",
  },
  {
    id: "interior-detail",
    title: "Interior Detail Package",
    description: "Keeping the interior like new is just as important as the exterior of your car. We use steam, odor eliminators and only top of the line products throughout cleaning.",
  },
  {
    id: "eco-wax",
    title: "ECO Wax Package",
    description: "Applying car wax regularly will extend the life and beauty of your vehicle's paint finish. We use only top of the line WAX products to make sure your car is safe.",
  },
  {
    id: "exterior-detailing",
    title: "Exterior Detailing Package",
    description: "Hand polishing is a great way to shine your car in between details. It is used to remove grease, dirt, and scratches that cannot be removed from washing.",
  },
  {
    id: "ceramic-coatings",
    title: "Ceramic Coatings",
    description: "Ceramic coating is a complex multi-stage process that protects from external paint damage and offers a better protection from scratches, dust and rust.",
  },
];

const ServicesSection = () => {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-br from-white via-blue-50 to-blue-200 animate-on-scroll opacity-0">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary text-center mb-8 md:mb-12">
          Twin Cities Auto Detailing Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <Card
              key={service.id}
              className="hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <CardContent className="p-4 md:p-6 text-center">
                <h3 className="text-lg md:text-xl font-semibold text-primary mb-3 md:mb-4">
                  {service.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4">{service.description}</p>
                <Link to="/services" className="text-primary hover:underline">
                  Learn More
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="text-center mt-8 md:mt-10">
          <Link to="/services" className="inline-block bg-primary text-white px-5 py-2 md:px-6 md:py-3 rounded-md font-medium hover:bg-primary-dark transition-colors text-sm md:text-base">
            View All Services & Pricing
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
